import { defineComponent as _defineComponent } from 'vue'
import { computed, toRefs } from 'vue';
import SortableColumnHeader from './SortableColumnHeader.vue';
import type { ColumnInfo, ElementUISlotScope } from '@/lib/types';
import { Order } from '@/mixins/filterHandler/lib';

/**
 * ElTableColumnTwoFields - Componente per colonne tabella con due campi
 *
 * Visualizza due campi dello stesso oggetto in una colonna:
 * - Campo primario sopra (dimensione normale)
 * - Campo secondario sotto (grigio piccolo)
 *
 * Sostituisce il pattern ripetuto di "leading-tight" con due div
 * presenti in molte tabelle del progetto.
 */

// Definizione props con TypeScript
interface Props {
	/** Campo primario da mostrare sopra (default: 'code') */
	primaryField?: string;
	/** Campo secondario da mostrare sotto in grigio (default: 'name') */
	secondaryField?: string;
	/** Abilita il sorting */
	sortable?: boolean;
	/** Campo da usare per l'ordinamento (default: usa primaryField) */
	orderByField?: string;
	/** Ordine corrente per il SortableColumnHeader */
	dataOrder?: Order | null;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ElTableColumnTwoFields',
  props: {
    primaryField: { default: 'code' },
    secondaryField: { default: 'name' },
    sortable: { type: Boolean, default: false },
    orderByField: { default: '' },
    dataOrder: { default: null }
  },
  emits: ['orderChanged'],
  setup(__props: any, { emit }) {

const props = __props as { primaryField: string, secondaryField: string, sortable: boolean, orderByField: string, dataOrder: Order | null };



// Events


// Handler per order-change event
const handleOrderChange = (property: string, operator: any) => {
	emit('orderChanged', property, operator);
};

// Refs per props (per accesso nel template)
const { sortable } = toRefs(props);

// Computed - Campo per ordinamento (priorità alla prop esplicita, fallback al primaryField)
const computedOrderByField = computed(() => {
	return props.orderByField || props.primaryField;
});

// Utility function per risolvere proprietà nested negli oggetti
const _resolveObjProp = (path: string, obj: any): any => {
	return path.split('.').reduce((prev, curr) => {
		return prev ? prev[curr] : null;
	}, obj || null);
};

// Methods - Ottiene il valore del campo primario
const getPrimaryValue = (row: any): string => {
	const value = _resolveObjProp(props.primaryField, row);
	return value && value !== '' ? value : '';
};

// Methods - Ottiene il valore del campo secondario
const getSecondaryValue = (row: any): string => {
	const value = _resolveObjProp(props.secondaryField, row);
	return value && value !== '' ? value : '';
};

// Methods - Informazioni colonna per SortableColumnHeader
const _columnInfo = (column: ElementUISlotScope['column']): ColumnInfo => {
	// Usa SOLO la proprietà della colonna (prop) per il sorting
	return {
		column: {
			property: column.property,
			label: column.label,
		},
	};
};

return { __sfc: true,props, emit, handleOrderChange, sortable, computedOrderByField, _resolveObjProp, getPrimaryValue, getSecondaryValue, _columnInfo, SortableColumnHeader }
}

})